import React, { useEffect } from "react";
import { Button, Empty } from "antd";
import { useNavigate } from "react-router-dom";

import useJDStore from "../../store/jd.store";
import { useLocation } from "react-router-dom";

import Table from "../Table";

import "./jds.scss";

export default function MyJds(props) {
  console.log(props);

  const navigate = useNavigate();

  const status = localStorage.getItem("status");
  const userData = JSON.parse(localStorage.getItem("userDetails"));
  const { getAllJds, jdData } = useJDStore();

  useEffect(() => {
    getAllJds();
  }, [status]);


  const titleList = [
    "Sr. No.",
    "Assigned On",   
    "Client",
    "TA",
    "Job Title",
    "Priority",
    "Total Resumes", 
    "SPOC",
    "Assigned To",
    "BU/Project Name",
    "Hiring Manager",
  ];

  var assignedJdsDetailData = []
  const jdsDetailData = jdData?.map((jds, idx) => {
    var aData
    var count=0

    if(jds?.JDAssignment?.Assignments?.[0].AssignedToName == userData.username ){
      aData =  {
        id: count + 1,
        date_added: jds?.JDAssignment?.AssignedOn,
        client_name: jds?.JDClient.ClientName,
        ta: jds?.JDClient.TaName,
        title: '['+jds?.QhCompanyJID+'] '+jds?.JDDetails.Title,
        priority: jds?.JDOther?.Priority,
        total_length: jds?.JDResumeList?.length,
        SPOC: jds?.JDAssignment?.Spoc,
        assignedTo: jds?.JDAssignment?.Assignments?.[0].AssignedToName,
        bu: jds?.hiring_project_team_name,
        hiring_project_team_name: jds?.hiring_project_team_name,
      };
      assignedJdsDetailData.push(aData)
      count = count+1
    }
    return aData
  });

  return (
    <div className="jds-wrapper">
      {assignedJdsDetailData?.length > 0 ? (
        <Table
          isClickable={true}
          isJDPage={true}
          titleList={titleList}
          data={assignedJdsDetailData}
        />
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}
    </div>
  );
}
